import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Copy } from "lucide-react";

/**
 * Single row in the admin waitlist table.
 * Kept intentionally small — no data fetching here.
 */
export default function AdminWaitlistRow({ row, onCopy, onInvite }) {
  return (
    <motion.tr
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="border-b border-white/5 hover:bg-white/5"
      data-testid={`admin-row-${row.email}`}
    >
      <td className="py-3 pr-4 font-mono">
        <span className="text-white/60 line-through mr-1">{row.position}</span>
        <span className="text-neon-lime font-bold">#{row.effective_position}</span>
      </td>
      <td className="py-3 pr-4 font-mono text-white">{row.email}</td>
      <td className="py-3 pr-4 text-white/70 max-w-xs truncate">
        {row.business_idea || <span className="text-white/30">—</span>}
      </td>
      <td className="py-3 pr-4 font-mono text-neon-lime">{row.referrals_count || 0}</td>
      <td className="py-3 pr-4 font-mono text-white/60">{row.referred_by || "—"}</td>
      <td className="py-3 pr-4">
        {row.invited ? (
          <span className="px-2 py-0.5 rounded-full bg-neon-lime/20 text-neon-lime text-xs font-mono">invited</span>
        ) : (
          <span className="px-2 py-0.5 rounded-full bg-white/5 text-white/60 text-xs font-mono">waiting</span>
        )}
      </td>
      <td className="py-3 pr-4 flex gap-2">
        <button
          data-testid={`admin-copy-${row.email}`}
          onClick={() => onCopy(row.email)}
          className="p-1.5 rounded-full bg-white/5 hover:bg-white/10 text-white/70"
          title="Copy email"
        >
          <Copy className="w-3.5 h-3.5" />
        </button>
        {!row.invited && (
          <Button
            data-testid={`admin-invite-${row.email}`}
            onClick={() => onInvite(row.email)}
            className="rounded-full bg-neon-pink hover:bg-neon-pink/90 text-white text-xs font-bold h-7 px-3"
          >
            Invite
          </Button>
        )}
      </td>
    </motion.tr>
  );
}
